import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import 'react-perfect-scrollbar/dist/css/styles.min.css'
import './css/cascaderMenu.css'
// import $ from 'jquery';
import Popper from 'popper.js';
import reportWebVitals from './reportWebVitals';
import SimpleReactLightbox from "simple-react-lightbox";
import * as serviceWorker from './serviceworker';
import swDev from './swDev'


ReactDOM.render(
  <React.StrictMode>
      <SimpleReactLightbox>
          <App />
      </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById('root')
);
// swDev();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// serviceWorker.register();
reportWebVitals();
